const { VITE_TOKEN_REGEX } = typeof import.meta !== 'undefined' ? import.meta.env : process.env;

export const isTokenValid = (token)=> {
    const regex = new RegExp(VITE_TOKEN_REGEX);
    return regex.test(token);
}